import styled from 'styled-components';

export type BadgeColor = 'warning' | 'success' | 'upstream' | 'autonomousSystem' | 'default';

export interface BadgeProps {
  badgeColor?: BadgeColor;
}

export const Badge: React.FC<BadgeProps> = ({ badgeColor }) => (
  <div className="h-full flex items-center">
    <BaseBadge badgeColor={badgeColor} />
  </div>
);

const BaseBadge = styled.div<BadgeProps>`
  width: 0.3rem;
  height: 3rem;
  background-color: ${(props) => {
    switch (props.badgeColor) {
      case 'warning':
        return '#F2994A';
      case 'success':
        return '#6FCF97';
      case 'upstream':
        return '#24b8e8';
      case 'autonomousSystem':
        return '#f3efef';
      default:
        return '#C4C4C4';
    }
  }};
`;
